'use strict';

module.exports = require('./Switch');


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/~/_rc-switch@1.5.3@rc-switch/lib/index.js
// module id = 902
// module chunks = 0 1